import { useSelector } from 'react-redux'

import { selectInternalDerivedMetrics } from 'redux/selectors/internal/DerivedMetrics'

export const useInternalDerivedMetrics = () => {
  return useSelector(selectInternalDerivedMetrics)
}
